import { useState, useEffect } from "react";

// ── Shared responsive breakpoint ────────────────────────────────────────────
// Single source of truth for "mobile" across the app. iPhones (SE through Pro
// Max, portrait) fall under 768px; anything at/above is treated as desktop or
// tablet-landscape and gets the existing fixed-width layouts.
export const MOBILE_BP = 768;

// useIsMobile — matchMedia-based, so it reacts live to orientation changes /
// resizing (e.g. rotating a phone) without a resize-event listener + rAF
// throttling. Returns a plain boolean.
export function useIsMobile(breakpoint = MOBILE_BP) {
  const query = `(max-width: ${breakpoint - 1}px)`;
  const [isMobile, setIsMobile] = useState(
    () => typeof window !== "undefined" && window.matchMedia(query).matches
  );

  useEffect(() => {
    const mql = window.matchMedia(query);
    const handler = (e) => setIsMobile(e.matches);
    // Safari < 14 only supports addListener/removeListener; modern browsers
    // support addEventListener. Support both without breaking either.
    if (mql.addEventListener) mql.addEventListener("change", handler);
    else mql.addListener(handler);
    setIsMobile(mql.matches);
    return () => {
      if (mql.removeEventListener) mql.removeEventListener("change", handler);
      else mql.removeListener(handler);
    };
  }, [query]);

  return isMobile;
}
